// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Sxh8","modalForm":"UpgradeEpcsModal_modalForm__47QLV","modalFooter":"UpgradeEpcsModal_modalFooter__3hA1M"};